/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* MASHQ — the WishlistHero header heart (ported from the 5.1.0 header snippet)
   was removed 2026-09-22 (CONVERSION-2000 #1063): the app's script no longer
   loads on any page, so the heart linked to `#hero-wishlist` — a dead control
   beside the cart on every screen, competing with the one button that matters. */

/* MASHQ custom — referral link attribution (no login required, no auto-discount).
   Usage: share a link like https://mashq.ae/?ref=PARTNERCODE
   The referral code is remembered for 30 days and attached to the order as an
   "Additional details" attribute called "Referral Code", so MASHQ can identify
   which completed orders came from which referral partner and calculate the
   5% commission manually against genuine UAE orders. */
(function () {
  var REF_PARAM = 'ref';
  var STORAGE_KEY = 'mashq_referral';
  var MAX_AGE_DAYS = 30;

  function getUrlParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name);
    } catch (e) {
      return null;
    }
  }

  function saveReferral(code) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ code: code, ts: Date.now() }));
    } catch (e) {}
  }

  function getStoredReferral() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      var ageDays = (Date.now() - data.ts) / (1000 * 60 * 60 * 24);
      if (ageDays > MAX_AGE_DAYS) return null;
      return data.code;
    } catch (e) {
      return null;
    }
  }

  function attachReferralToCart(code) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Referral Code': code } })
    }).catch(function () {});
  }

  var incomingRef = getUrlParam(REF_PARAM);
  if (incomingRef && incomingRef.trim() !== '') {
    saveReferral(incomingRef.trim());
  }

  var activeRef = getStoredReferral();
  if (activeRef) {
    attachReferralToCart(activeRef);
  }
})();

/* MASHQ custom — back-to-top button (7.1.0) */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.mashq-to-top')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mashq-to-top';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    document.body.appendChild(btn);
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    var toggle = function () {
      if (window.pageYOffset > 650) { btn.classList.add('is-visible'); } else { btn.classList.remove('is-visible'); }
    };
    window.addEventListener('scroll', toggle, { passive: true });
    toggle();
  });
})();

/* MASHQ — the bilingual footer trust strip (7.1.0) was removed 2026-09-22: its
   four facts live in sections/mashq-values.liquid now, one language per page,
   and "Handcrafted in Dubai" had outlived the made-in-the-UAE rule. */
